"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLogo = exports.StyledGalleryLinkBox = exports.MobileMainIcon = exports.MobileSocialBox = exports.MobileHamburgerMenu = exports.StyledShareIconBox = exports.MainIcon = exports.SocialBox = exports.NavLinkBox = exports.TopnavBox = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

var _Elements = require("../../../../Elements");

var _constants = require("../../../../constants/constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var themeTopNavHeight = _constants.adamsDimensions.themeTopNavHeight;
var TopnavBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__TopnavBox",
  componentId: "sc-101etr1-0"
})(["position:sticky;height:", ";top:0;z-index:3;padding:0 ", ";background:", ";", " svg{path{fill:", ";}}.navlink-selected{color:", ";font-weight:bold;}"], themeTopNavHeight, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.isDesktop && (0, _styledComponents.css)(["padding:0 48px;"]);
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme[props.fontColor];
});
exports.TopnavBox = TopnavBox;
var NavLinkBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__NavLinkBox",
  componentId: "sc-101etr1-1"
})(["margin-left:40px;cursor:pointer;.popover-wrapper{background:", ";}a{&:hover{color:", " !important;font-weight:bold;p{color:", ";}}}"], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.theme[props.fontColor];
}, function (props) {
  return props.theme[props.fontColor];
});
exports.NavLinkBox = NavLinkBox;
var SocialBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__SocialBox",
  componentId: "sc-101etr1-2"
})(["& > div{margin-left:40px;}svg{path{fill:", ";}}"], function (props) {
  return props.theme.portfolioForeground1;
});
exports.SocialBox = SocialBox;

var MainIcon = _styledComponents["default"].div.withConfig({
  displayName: "Elements__MainIcon",
  componentId: "sc-101etr1-3"
})(["& > div{width:48px;height:12px;}svg{width:48px;height:12px;path{fill:", ";}}"], function (props) {
  return props.theme.portfolioForeground1;
});

exports.MainIcon = MainIcon;
var StyledShareIconBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledShareIconBox",
  componentId: "sc-101etr1-4"
})(["margin-left:40px;& > a > div{width:16px;height:16px;}svg{width:16px;height:16px;path{fill:", ";}}"], function (props) {
  return props.theme.portfolioForeground1;
});
exports.StyledShareIconBox = StyledShareIconBox;
var MobileHamburgerMenu = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__MobileHamburgerMenu",
  componentId: "sc-101etr1-5"
})(["position:absolute;height:calc(100vh - ", ");top:72px;left:0;background:", ";width:100%;box-sizing:border-box;padding:44px 0 60px;z-index:3;overflow-y:scroll;"], themeTopNavHeight, function (props) {
  return props.theme.portfolioBackground1;
});
exports.MobileHamburgerMenu = MobileHamburgerMenu;
var MobileSocialBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__MobileSocialBox",
  componentId: "sc-101etr1-6"
})(["position:relative;margin-top:56px;"]);
exports.MobileSocialBox = MobileSocialBox;

var MobileMainIcon = _styledComponents["default"].div.withConfig({
  displayName: "Elements__MobileMainIcon",
  componentId: "sc-101etr1-7"
})(["& > div{width:48px;height:24px;}svg{width:48px;height:24px;path{fill:", ";}}"], function (props) {
  return props.theme.portfolioForeground1;
});

exports.MobileMainIcon = MobileMainIcon;
var StyledGalleryLinkBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledGalleryLinkBox",
  componentId: "sc-101etr1-8"
})(["position:relative;svg{path{fill:", ";}}&:hover{> p{color:", ";font-weight:bold;}> p{span{color:", ";font-weight:bold;}}svg{path{fill:", ";}}}"], function (props) {
  return !props.isGalleryLink ? props.theme.portfolioForeground1 : props.theme[props.fontColor];
}, function (props) {
  return props.theme[props.fontColor];
}, function (props) {
  return props.theme[props.fontColor];
}, function (props) {
  return props.theme[props.fontColor];
});
exports.StyledGalleryLinkBox = StyledGalleryLinkBox;
var StyledLogo = (0, _styledComponents["default"])(_Elements.Logo).withConfig({
  displayName: "Elements__StyledLogo",
  componentId: "sc-101etr1-9"
})(["&:hover{a{color:", ";}}"], function (props) {
  return props.theme[props.colour];
});
exports.StyledLogo = StyledLogo;